import { render, staticRenderFns } from "./MetricSelector2.vue?vue&type=template&id=25aab666&scoped=true&"
import script from "./MetricSelector2.vue?vue&type=script&lang=js&"
export * from "./MetricSelector2.vue?vue&type=script&lang=js&"
import style0 from "./MetricSelector2.vue?vue&type=style&index=0&id=25aab666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aab666",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VBtnToggle,VCard,VChip,VIcon,VLayout,VList,VListItem,VListItemTitle,VMenu,VSelect})
